import React from 'react';
import { Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { showAlert } from 'features/applicationState';

import { AlarmRulesCount, AlertState, RootState } from 'types/types';

interface ActionTopBarProps {
  alarmsCount: AlarmRulesCount;
}

const ActionTopBar: React.FC<ActionTopBarProps> = ({ alarmsCount }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const maxAlarmCount = useSelector(
    (state: RootState) =>
      state.applicationState.applicationSettings.ALARM_MAX_NUMBER_OF_ALARMS
  );

  const handleButtonClick = () => {
    if (alarmsCount?.AllAlarms >= maxAlarmCount) {
      const alertData: AlertState = {
        severity: 'warning',
        title: 'Maximum Amount of Alarms Created',
        message: 'Maximum Amount of Alarms Created!',
        open: true,
      };
      dispatch(showAlert(alertData));
      setTimeout(() => {
        dispatch(showAlert({ ...alertData, open: false }));
      }, 3000);
    } else {
      navigate('/alarm-management/new');
    }
  };

  return (
    <div className="action-top-bar-container">
      <Button className="action-button" onClick={handleButtonClick}>
        Create a new Alarm
      </Button>
    </div>
  );
};

export default ActionTopBar;
